import { ColumnsType } from 'antd/es/table'
import moment from 'moment'
import { AnomalyDto } from 'api-client'

const typeLabels: Record<string, string> = {
  GoodsDiscount: 'Goods discount',
  FreeGoods: 'Free goods',
  FreeQuote: 'Free quote',
}

export const columns: ColumnsType<AnomalyDto> = [
  {
    title: 'Time',
    key: 'time',
    dataIndex: 'dateCreated',
    render: (value?: string) => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '—'),
  },
  {
    title: 'Type',
    key: 'type',
    dataIndex: 'type',
    render: (value?: string) => (value ? typeLabels[value] ?? value : '—'),
  },
  {
    title: 'Item',
    key: 'item',
    dataIndex: 'itemTitle',
    render: (value?: string) => value || '—',
  },
  {
    title: 'Item total',
    key: 'total',
    dataIndex: 'totalAmount',
  },
  {
    title: 'Discount / amount',
    key: 'amount',
    dataIndex: 'amount',
  },
  {
    title: 'Member',
    key: 'member',
    dataIndex: 'memberName',
    render: (value?: string) => value || '—',
  },
  {
    title: 'Cashier',
    key: 'assigner',
    dataIndex: 'assignerName',
    render: (value?: string) => value || '—',
  },
]
